import { createI18n } from 'vue-i18n';
// Languages
import ar from './ar';
import en from './en';

const messages = { ar, en };

const i18n = createI18n({
  locale: 'ar',
  messages,
});

export default i18n;
